import { UIText1 } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './ChatPhone.css';

type TProps = {
  phone: string;
  href: string;
  isOutcoming?: boolean;
};

export const ChatPhone: React.FC<TProps> = ({ phone, href, isOutcoming }) => {
  return (
    <a href={`tel:${href}`} target="_blank" className={classNames(isOutcoming && styles['underline'])}>
      <UIText1 display="inline" color={isOutcoming ? 'text-inverted-default' : 'text-main-default'}>
        {phone}
      </UIText1>
    </a>
  );
};
